/*
* @Author: Alexander.Vangelov@vonage.com
* @Date: 2020-07-01 16:00:51
 * @Last Modified by: Alexander.Vangelov@vonage.com
 * @Last Modified time: 2024-03-18 14:21:49
*/

import { core, IContactableRef, IDialerEvent, IEntityRef } from '../core';
import { CommonDialer } from '../ui/dialer';

export class DialerApi {
  readonly debug: boolean;
  readonly provider: 'uc' | 'cc';
  private dialer: CommonDialer;
  // worker: any;
  // c2d: any;

  constructor(config) {
    // this.button = core.dot.button;
    if (core.dialer) {
      this.dialer = core.dialer;
      this.provider = this.dialer.provider;
    }
    if (config && config.debug) {
      this.debug = true;
    }
  }

  registerSvgIcon(provider: string, dataUrl: string, callback?: (result) => void) {
    core.sendReceive('registerSvgIcon', { provider, dataUrl }, callback);
  }

  registerCustomSettings(provider: string, settings, callback?: (result) => void) {
    core.sendReceive('registerCustomSettings', { provider, settings }, callback);
  }

  getSettings(provider, callback?: (result) => void) {
    core.sendReceive('getSettings', { provider }, (response) => {
      if (typeof(callback) === 'function') {
        callback((response || {})['settings'] || {});
      }
    });
  }

  setOnSearchContactables(callback: (q: string, callback?: (contacts: Array<IContactableRef>) => void) => void) {
    core.onSearchContactables = callback;
  }

  setOnDialerEvent(callback: (data: IDialerEvent) => void) {
    core.onInteractionEvent = callback;
  }

  setOnOpenContactable(callback: (contact: IContactableRef) => void) {
    core.onOpenContactable = callback;
  }

  setInteractionContact(interactionId, contact: IContactableRef) {
    core.sendReceive('setInteractionContact', { id: interactionId, contact });
  }

  setVisibility(visible: boolean) {
    return this.dialer.setVisibility(visible);
  }

  placeCall(phoneNumber: string, entityRef?: IEntityRef) {
    return this.dialer.placeCall(phoneNumber, entityRef);
  }

  sendSms(phoneNumber: string, text?: string, entityRef?: IEntityRef) {
    return this.dialer.sendSms(phoneNumber, text, entityRef);
  }

  openPopup(url: string, type?: 'normal' | 'panel') {
    return this.dialer.openWeblaunchPopup({
      type: 'SCREEN_POP',
      data: {
        provider: 'WEBLAUNCH',
        id: url,
        type
      }
    });
  }

  // getSession(callback?: (result) => void) {
  //   core.sendReceive('getSession', null, (response) => {
  //     console.log('getSession response', response);
  //     if (typeof(callback) === 'function') {
  //       callback((response || {})['session'] || {});
  //     }
  //   });
  // }
}